export default "__VITE_ASSET__CGQhrNo9__"